// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== RESET BASIC ===== */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html, body {
  font-family: sans-serif;
  line-height: 1.5;
  color: #111827; /* gray-900 */
  background-color: #ffffff;
}
a {
  text-decoration: none;
  color: inherit;
}

/* ===== CONTAINERS ===== */
.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
}
.container h1{
  display: flex;
    margin: auto;
    justify-content: center;
}
.text-center {
  text-align: center;
}

/* ===== ICONS ===== */
.icon {
  display: flex;
  font-size: 40px;
  justify-content: center;
  align-items: center;
  margin: 10px autow;
}
.icon-small {
  width: 1rem;
  height: 1rem;
}

/* ===== NAVBAR ===== */
.navbar {
  background-color: #ffffff;
  border-bottom: 1px solid #f3f4f6; /* gray-100 */
}
.navbar-top {
  border-bottom: 1px solid #f3f4f6;
  padding: 0.5rem 0;
}
.navbar-info {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  font-size: 0.875rem;
  color: #4b5563; /* gray-600 */
}
.info-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.navbar-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
}
.logo {
  font-size: 1.25rem;
  font-weight: bold;
}
.nav-links {
  display: flex;
  gap: 2rem;
}
.nav-links a {
  position: relative;
  padding-bottom: 0.25rem;
}
.nav-links a.active {
  color: #111827;
  font-weight: bold;
}

/* ===== BREADCRUMB ===== */
.breadcrumb {
  background-color: #f9fafb; /* gray-50 */
  padding: 1rem 0;
}
.breadcrumb-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #4b5563;
}
.breadcrumb-content .current {
  color: #111827;
}

/* ===== HERO SECTION ===== */
.hero {
  padding: 3rem 0;
}
.hero h1 {
  font-size: 2.25rem;
  font-weight: 300;
}

/* ===== STATS SECTION ===== */
.stats {
  background-color: #f9fafb;
  padding: 2rem 0;
}
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit,minmax(150px,1fr));
  gap: 2rem;
  text-align: center;
}
.stat-number {
  font-size: 2rem;
  font-weight: bold;
  color: #111827;
}
.stat-label {
  color: #4b5563;
  font-size: 0.875rem;
}

/* ===== PROJECTS ===== */
.projects {
  padding: 4rem 0;
}
.projects h2 {
  font-size: 1.875rem;
  font-weight: 300;
  text-align: center;
  margin-bottom: 1rem;
}
.divider {
  width: 4rem;
  height: 2px;
  background-color: #111827;
  margin: 0 auto 3rem auto;
}
.projects-grid {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}
.project-card {
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.3s ease;
}
.project-card:hover {
  box-shadow: 0 4px 14px rgba(0,0,0,0.1);
}
.project-image {
  position: relative;
}
.project-image img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}
.project-category {
  position: absolute;
  bottom: 0.75rem;
  left: 0.75rem;
  background-color: rgba(17,24,39,0.9);
  color: white;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
}
.project-card h3 {
  font-size: 1.25rem;
  margin: 1rem;
  font-weight: 500;
}
.project-card p {
  font-size: 0.875rem;
  color: #4b5563;
  margin: 0 1rem 1rem 1rem;
  flex-grow: 1;
}
.project-info {
  display: flex;
  justify-content: space-between;
  padding: 0 1rem 1rem 1rem;
  font-size: 0.75rem;
  color: #6b7280;
}
.project-link {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 1rem;
  font-size: 0.875rem;
  color: #111827;
  cursor: pointer;
}

/* ===== SERVICES ===== */
.services {
  background-color: #f9fafb;
  padding: 4rem 0;
}
.services h2 {
  font-size: 1.875rem;
  font-weight: 300;
  text-align: center;
  margin-bottom: 1rem;
}
.services-grid {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit,minmax(250px,1fr));
}
.service-item {
  background-color: white;
  border: 1px solid #e5e7eb;
  padding: 2rem;
  border-radius: 0.5rem;
  text-align: center;
}
.service-item h3 {
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
}
.service-item p {
  font-size: 0.875rem;
  color: #4b5563;
}

/* ===== PROCESS ===== */
.process {
  padding: 4rem 0;
}
.process-grid {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit,minmax(120px,1fr));
}
.process-item {
  text-align: center;
}
.process-step {
  font-size: 2rem;
  font-weight: bold;
  color: #111827;
  margin-bottom: 0.5rem;
}
.process-item p {
  font-size: 0.875rem;
  color: #4b5563;
}

/* ===== CTA SECTION ===== */
.cta {
  background-color: #111827;
  color: white;
  padding: 4rem 0;
}
.cta h2 {
  font-size: 1.875rem;
  font-weight: 300;
  margin-bottom: 1rem;
}
.cta p {
  font-size: 1rem;
  font-weight: 300;
  margin-bottom: 2rem;
}
.cta-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}
.btn-primary {
  border: 1px solid #111827;
  background-color: white;
  color: #111827;
  padding: 0.75rem 2rem;
  font-size: 0.875rem;
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: all 0.3s ease;
}
.btn-primary:hover {
  background-color: #111827;
  color: white;
}
.btn-secondary {
  border: 1px solid #d1d5db;
  background-color: transparent;
  color: #ffffff;
  padding: 0.75rem 2rem;
  font-size: 0.875rem;
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: all 0.3s ease;
}
.btn-secondary:hover {
  border-color: #ffffff;
  color: #ffffff;
}
.seo-comprehensive {
  background-color: #f9fafb;
  padding: 4rem 0;
}

.seo-comprehensive h2 {
  font-size: 1.875rem;
  font-weight: 300;
  text-align: center;
  margin-bottom: 1rem;
}

.seo-intro {
  text-align: center;
  margin-bottom: 3rem;
  font-size: 1rem;
  color: #4b5563;
  line-height: 1.6;
}

.seo-products-grid {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  margin-bottom: 4rem;
}

.seo-product-card {
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.3s ease;
  background-color: white;
}

.seo-product-card:hover {
  box-shadow: 0 4px 14px rgba(0,0,0,0.1);
}

.seo-product-image {
  position: relative;
}

.seo-product-image img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.seo-product-content {
  padding: 1.5rem;
}

.seo-product-content h3 {
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #111827;
}

.seo-product-content p {
  font-size: 0.875rem;
  color: #4b5563;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.seo-locations {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
  color: #6b7280;
}

.seo-keywords {
  font-size: 0.75rem;
  color: #9ca3af;
  font-style: italic;
}

.location-offers {
  padding: 4rem 0;
  background-color: white;
}

.location-offers h2 {
  font-size: 1.875rem;
  font-weight: 300;
  text-align: center;
  margin-bottom: 1rem;
}

.location-offers-grid {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}

.location-offer-card {
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  padding: 2rem;
  border-radius: 0.5rem;
}

.location-offer-card h3 {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: #111827;
  font-weight: 500;
  text-align: center;
}

.offers-list {
  list-style: none;
  padding: 0;
}

.offers-list li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
  color: #4b5563;
}

.seo-faq {
  background-color: #f9fafb;
  padding: 4rem 0;
}

.seo-faq h2 {
  font-size: 1.875rem;
  font-weight: 300;
  text-align: center;
  margin-bottom: 1rem;
}

.faq-grid {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}

.faq-item {
  background-color: white;
  border: 1px solid #e5e7eb;
  padding: 2rem;
  border-radius: 0.5rem;
}

.faq-item h3 {
  font-size: 1.125rem;
  margin-bottom: 0.75rem;
  color: #111827;
  font-weight: 500;
}

.faq-item p {
  font-size: 0.875rem;
  color: #4b5563;
  line-height: 1.5;
}

.seo-keywords-section {
  padding: 4rem 0;
  background-color: white;
}

.seo-keywords-section h2 {
  font-size: 1.875rem;
  font-weight: 300;
  text-align: center;
  margin-bottom: 1rem;
}

.keywords-categories {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
}

.keyword-category {
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  padding: 2rem;
  border-radius: 0.5rem;
}

.keyword-category h3 {
  font-size: 1.125rem;
  margin-bottom: 1rem;
  color: #111827;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.keyword-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.keyword-tag {
  background-color: #e5e7eb;
  color: #374151;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 500;
}

.icon-small {
  width: 1rem;
  height: 1rem;
}

.divider {
  width: 4rem;
  height: 2px;
  background-color: #111827;
  margin: 0 auto 3rem auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Proiecte.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc,EAAE,aAAa;EAC7B,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;IACX,YAAY;IACZ,uBAAuB;AAC3B;AACA;EACE,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,gCAAgC,EAAE,aAAa;AACjD;AACA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,cAAc,EAAE,aAAa;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB,EAAE,YAAY;EACvC,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;EACb,yDAAyD;EACzD,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,yDAAyD;AAC3D;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;EACT,yDAAyD;AAC3D;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,wBAAwB;AAC1B","sourcesContent":["/* ===== RESET BASIC ===== */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\nhtml, body {\n  font-family: sans-serif;\n  line-height: 1.5;\n  color: #111827; /* gray-900 */\n  background-color: #ffffff;\n}\na {\n  text-decoration: none;\n  color: inherit;\n}\n\n/* ===== CONTAINERS ===== */\n.container {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 1rem;\n}\n.container h1{\n  display: flex;\n    margin: auto;\n    justify-content: center;\n}\n.text-center {\n  text-align: center;\n}\n\n/* ===== ICONS ===== */\n.icon {\n  display: flex;\n  font-size: 40px;\n  justify-content: center;\n  align-items: center;\n  margin: 10px autow;\n}\n.icon-small {\n  width: 1rem;\n  height: 1rem;\n}\n\n/* ===== NAVBAR ===== */\n.navbar {\n  background-color: #ffffff;\n  border-bottom: 1px solid #f3f4f6; /* gray-100 */\n}\n.navbar-top {\n  border-bottom: 1px solid #f3f4f6;\n  padding: 0.5rem 0;\n}\n.navbar-info {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  font-size: 0.875rem;\n  color: #4b5563; /* gray-600 */\n}\n.info-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.navbar-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 0;\n}\n.logo {\n  font-size: 1.25rem;\n  font-weight: bold;\n}\n.nav-links {\n  display: flex;\n  gap: 2rem;\n}\n.nav-links a {\n  position: relative;\n  padding-bottom: 0.25rem;\n}\n.nav-links a.active {\n  color: #111827;\n  font-weight: bold;\n}\n\n/* ===== BREADCRUMB ===== */\n.breadcrumb {\n  background-color: #f9fafb; /* gray-50 */\n  padding: 1rem 0;\n}\n.breadcrumb-content {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  color: #4b5563;\n}\n.breadcrumb-content .current {\n  color: #111827;\n}\n\n/* ===== HERO SECTION ===== */\n.hero {\n  padding: 3rem 0;\n}\n.hero h1 {\n  font-size: 2.25rem;\n  font-weight: 300;\n}\n\n/* ===== STATS SECTION ===== */\n.stats {\n  background-color: #f9fafb;\n  padding: 2rem 0;\n}\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit,minmax(150px,1fr));\n  gap: 2rem;\n  text-align: center;\n}\n.stat-number {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #111827;\n}\n.stat-label {\n  color: #4b5563;\n  font-size: 0.875rem;\n}\n\n/* ===== PROJECTS ===== */\n.projects {\n  padding: 4rem 0;\n}\n.projects h2 {\n  font-size: 1.875rem;\n  font-weight: 300;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n.divider {\n  width: 4rem;\n  height: 2px;\n  background-color: #111827;\n  margin: 0 auto 3rem auto;\n}\n.projects-grid {\n  display: grid;\n  gap: 2rem;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n}\n.project-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  transition: box-shadow 0.3s ease;\n}\n.project-card:hover {\n  box-shadow: 0 4px 14px rgba(0,0,0,0.1);\n}\n.project-image {\n  position: relative;\n}\n.project-image img {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n}\n.project-category {\n  position: absolute;\n  bottom: 0.75rem;\n  left: 0.75rem;\n  background-color: rgba(17,24,39,0.9);\n  color: white;\n  font-size: 0.75rem;\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n}\n.project-card h3 {\n  font-size: 1.25rem;\n  margin: 1rem;\n  font-weight: 500;\n}\n.project-card p {\n  font-size: 0.875rem;\n  color: #4b5563;\n  margin: 0 1rem 1rem 1rem;\n  flex-grow: 1;\n}\n.project-info {\n  display: flex;\n  justify-content: space-between;\n  padding: 0 1rem 1rem 1rem;\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n.project-link {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 1rem;\n  font-size: 0.875rem;\n  color: #111827;\n  cursor: pointer;\n}\n\n/* ===== SERVICES ===== */\n.services {\n  background-color: #f9fafb;\n  padding: 4rem 0;\n}\n.services h2 {\n  font-size: 1.875rem;\n  font-weight: 300;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n.services-grid {\n  display: grid;\n  gap: 2rem;\n  grid-template-columns: repeat(auto-fit,minmax(250px,1fr));\n}\n.service-item {\n  background-color: white;\n  border: 1px solid #e5e7eb;\n  padding: 2rem;\n  border-radius: 0.5rem;\n  text-align: center;\n}\n.service-item h3 {\n  font-size: 1.25rem;\n  margin-bottom: 0.5rem;\n}\n.service-item p {\n  font-size: 0.875rem;\n  color: #4b5563;\n}\n\n/* ===== PROCESS ===== */\n.process {\n  padding: 4rem 0;\n}\n.process-grid {\n  display: grid;\n  gap: 2rem;\n  grid-template-columns: repeat(auto-fit,minmax(120px,1fr));\n}\n.process-item {\n  text-align: center;\n}\n.process-step {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #111827;\n  margin-bottom: 0.5rem;\n}\n.process-item p {\n  font-size: 0.875rem;\n  color: #4b5563;\n}\n\n/* ===== CTA SECTION ===== */\n.cta {\n  background-color: #111827;\n  color: white;\n  padding: 4rem 0;\n}\n.cta h2 {\n  font-size: 1.875rem;\n  font-weight: 300;\n  margin-bottom: 1rem;\n}\n.cta p {\n  font-size: 1rem;\n  font-weight: 300;\n  margin-bottom: 2rem;\n}\n.cta-buttons {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.btn-primary {\n  border: 1px solid #111827;\n  background-color: white;\n  color: #111827;\n  padding: 0.75rem 2rem;\n  font-size: 0.875rem;\n  font-weight: 300;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n.btn-primary:hover {\n  background-color: #111827;\n  color: white;\n}\n.btn-secondary {\n  border: 1px solid #d1d5db;\n  background-color: transparent;\n  color: #ffffff;\n  padding: 0.75rem 2rem;\n  font-size: 0.875rem;\n  font-weight: 300;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n.btn-secondary:hover {\n  border-color: #ffffff;\n  color: #ffffff;\n}\n.seo-comprehensive {\n  background-color: #f9fafb;\n  padding: 4rem 0;\n}\n\n.seo-comprehensive h2 {\n  font-size: 1.875rem;\n  font-weight: 300;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.seo-intro {\n  text-align: center;\n  margin-bottom: 3rem;\n  font-size: 1rem;\n  color: #4b5563;\n  line-height: 1.6;\n}\n\n.seo-products-grid {\n  display: grid;\n  gap: 2rem;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  margin-bottom: 4rem;\n}\n\n.seo-product-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  transition: box-shadow 0.3s ease;\n  background-color: white;\n}\n\n.seo-product-card:hover {\n  box-shadow: 0 4px 14px rgba(0,0,0,0.1);\n}\n\n.seo-product-image {\n  position: relative;\n}\n\n.seo-product-image img {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n}\n\n.seo-product-content {\n  padding: 1.5rem;\n}\n\n.seo-product-content h3 {\n  font-size: 1.25rem;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #111827;\n}\n\n.seo-product-content p {\n  font-size: 0.875rem;\n  color: #4b5563;\n  margin-bottom: 1rem;\n  line-height: 1.5;\n}\n\n.seo-locations {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n.seo-keywords {\n  font-size: 0.75rem;\n  color: #9ca3af;\n  font-style: italic;\n}\n\n.location-offers {\n  padding: 4rem 0;\n  background-color: white;\n}\n\n.location-offers h2 {\n  font-size: 1.875rem;\n  font-weight: 300;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.location-offers-grid {\n  display: grid;\n  gap: 2rem;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n}\n\n.location-offer-card {\n  background-color: #f9fafb;\n  border: 1px solid #e5e7eb;\n  padding: 2rem;\n  border-radius: 0.5rem;\n}\n\n.location-offer-card h3 {\n  font-size: 1.25rem;\n  margin-bottom: 1rem;\n  color: #111827;\n  font-weight: 500;\n  text-align: center;\n}\n\n.offers-list {\n  list-style: none;\n  padding: 0;\n}\n\n.offers-list li {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n  font-size: 0.875rem;\n  color: #4b5563;\n}\n\n.seo-faq {\n  background-color: #f9fafb;\n  padding: 4rem 0;\n}\n\n.seo-faq h2 {\n  font-size: 1.875rem;\n  font-weight: 300;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.faq-grid {\n  display: grid;\n  gap: 2rem;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n}\n\n.faq-item {\n  background-color: white;\n  border: 1px solid #e5e7eb;\n  padding: 2rem;\n  border-radius: 0.5rem;\n}\n\n.faq-item h3 {\n  font-size: 1.125rem;\n  margin-bottom: 0.75rem;\n  color: #111827;\n  font-weight: 500;\n}\n\n.faq-item p {\n  font-size: 0.875rem;\n  color: #4b5563;\n  line-height: 1.5;\n}\n\n.seo-keywords-section {\n  padding: 4rem 0;\n  background-color: white;\n}\n\n.seo-keywords-section h2 {\n  font-size: 1.875rem;\n  font-weight: 300;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.keywords-categories {\n  display: grid;\n  gap: 2rem;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n}\n\n.keyword-category {\n  background-color: #f9fafb;\n  border: 1px solid #e5e7eb;\n  padding: 2rem;\n  border-radius: 0.5rem;\n}\n\n.keyword-category h3 {\n  font-size: 1.125rem;\n  margin-bottom: 1rem;\n  color: #111827;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.keyword-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.keyword-tag {\n  background-color: #e5e7eb;\n  color: #374151;\n  padding: 0.25rem 0.75rem;\n  border-radius: 1rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.icon-small {\n  width: 1rem;\n  height: 1rem;\n}\n\n.divider {\n  width: 4rem;\n  height: 2px;\n  background-color: #111827;\n  margin: 0 auto 3rem auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
